/**
 * Logo Slider Block JavaScript
 */
class Slider {

	/**
	 * Static container width for marquee calculations
	 * @type {number}
	 * This is used to determine how many clones are needed for smooth scrolling
	 */
	static containerWidth = 1440;

	/**
	 * Buffer for marquee clones to ensure smooth scrolling
	 * @type {number}
	 */
	static cloneBuffer = 2;

	/**
	 * Initialize Slider functionality for all Slider blocks
	 */
	static init() {

		document.querySelectorAll( '.b-slider' ).forEach( slider => new Slider( slider ) );

	}

	/**
	 * Constructor for Slider class
	 * @param {HTMLElement} element The Slider block element
	 */
	constructor( element ) {

		this.element = element;
		this.resizeTimeout = null;
		this.scrollEl = this.element.querySelector( '.js-slider-scroll' );
		this.initialize();
		this.setupEventListeners();

	}

	/**
	 * Initialize the slider
	 */
	initialize() {

		this.handleResponsiveLayout();

	}

	/**
	 * Setup event listeners
	 */
	setupEventListeners() {

		window.addEventListener( 'resize', () => {

			clearTimeout( this.resizeTimeout );
			this.resizeTimeout = setTimeout( () => this.handleResponsiveLayout(), 250 );

		} );

	}


	/**
	 * Update animation duration and handle marquee cloning
	 */
	updateAnimationDuration() {

		const marqueeScroll = this.scrollEl.querySelector( '.js-slider-marquee' );
		const marquee = this.scrollEl.querySelector( '.js-slider-marquee-item' );
		if ( !marquee || !marqueeScroll ) {

			return;

		}

		// Remove all existing clones
		marqueeScroll.querySelectorAll( '.js-slider-marquee-item.clone' ).forEach( clone => {

			clone.parentNode.removeChild( clone );

		} );



		const allMarqueeItems = marqueeScroll.querySelectorAll( '.js-slider-marquee-item' );
		allMarqueeItems.forEach( item => item.classList.remove( 'b-slider__marquee-item--play' ) );
		void marquee.offsetWidth;
		setTimeout( () => {

			marqueeScroll.querySelectorAll( '.js-slider-marquee-item' ).forEach( item => {

				item.classList.add( 'b-slider__marquee-item--play' );

			} );

		}, 10 );

		const marqueeClone = marquee.cloneNode( true );
		marqueeClone.classList.add( 'clone' );
		marqueeScroll.appendChild( marqueeClone );


	}

	/**
	 * Handle responsive behavior and cleanup for grid mode
	 */
	handleResponsiveLayout() {

		if ( !this.scrollEl ) {

			return;

		}

		this.element.classList.remove( 'b-slider--responsive-grid' );
		this.element.classList.remove( 'b-slider--responsive-slider' );
		this.element.classList.add( 'b-slider--responsive-slider' );

		setTimeout( () => {

			this.updateAnimationDuration();

		}, 10 );



	}

}

document.addEventListener( 'DOMContentLoaded', Slider.init );
